import MicroModal from 'micromodal'
import ee from '../ee'

function init() {
  MicroModal.init({
    awaitCloseAnimation: true,
    onShow: (modal) => {
      ee.emit(`${modal.id}Opened`)
    },
    onClose: (modal) => {
      ee.emit(`${modal.id}Closed`)
    },
  })
}

ee.addListener('initComponents', init)
